module.exports = __webpack_public_path__ + "media/system/active-microphone-fa2b8bf6.svg";